<script async setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
  value: string | number;
}>();

const status = ref<boolean>(false);

const copy = () => {
  status.value = true;
  navigator.clipboard.writeText(String(props.value));

  setTimeout(() => {
    status.value = false;
  }, 2000);
};
</script>

<template>
  <div class="icon" @click="copy">
    <Transition name="fade">
      <svg
        v-if="status"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 12.0547L8.25742 17.2961C8.6477 17.6852 9.2792 17.6852 9.66948 17.2961L21 6"
          stroke="#27303E"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
      <svg
        v-else
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="copy"
      >
        <rect x="4" y="8" width="12" height="12" rx="2" stroke-width="2" />
        <path
          d="M9 5V5C9 3.89543 9.89543 3 11 3H19C20.1046 3 21 3.89543 21 5V13C21 14.1046 20.1046 15 19 15V15"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </Transition>
  </div>
</template>

<style scoped lang="scss">
.copy {
  cursor: pointer;
  transition: 0.3s all;
  display: block;
  stroke: var(--color-mono-200);

  &:hover {
    stroke: var(--color-mono-900);
  }
}

.icon {
  width: 48px;
  height: 48px;
  min-width: 48px;
  position: relative;

  svg {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 12px;
    position: absolute;
  }

  @media screen and (max-width: 380px) {
    width: 36px;
    min-width: 36px;
    border-radius: 8px;

    svg {
      padding: 8px;
    }
  }
}
</style>
